import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import CommonIcon from '../../helpers/icons';
import $ from "jquery";
import chroma from "chroma-js";
import axios from 'axios';
import API from '../../helpers/endpointservice';
import { logoutFunction } from '../../custom/logoutFunction';

const styles = {
    placeholder: (provided) => ({
        ...provided,
        whiteSpace : "noWrap",
        textOverflow : "ellipsis",
    })
}

const proficiencyOptions =
  [
    {
      label: "Master",
      value: "45,Master",
      color: "#21a366"
    },
    {
      label: "Competent",
      value: "46,Competent",
      color: "#4c4bfe"
    },
    {
      label: "Learner",
      value: "47,Learner",
      color: "#EC930D"
    },
    {
      label: "NA",
      value: "48,NA",
      color: "#A52A2A"
    },
    {
      label: "Novice",
      value: "50,Novice",
      color: "#EAD51A"
    }
];

const colorStyles = {
  control: (styles) => ({ ...styles, backgroundColor: "white" }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    const color = chroma(data.color);
    return {
      ...styles,
      backgroundColor: isDisabled
        ? null
        : isSelected
          ? data.color
          : isFocused
            ? color.alpha(0.1).css()
            : null,
      color: isDisabled
        ? "#ccc"
        : isSelected
          ? chroma.contrast(color, "white") > 2
            ? "white"
            : "black"
          : data.color,
      cursor: isDisabled ? "not-allowed" : "default",

      ":active": {
        ...styles[":active"],
        backgroundColor:
          !isDisabled && (isSelected ? data.color : color.alpha(0.3).css()),
      },
    };
  }
};

let obj = {
  "job": "",
  "jobGroup": "",
  "skillId": 0,
  "skill": "",
  "level": "",
  "proficiency": "",
  "proficiencyId": 0,
  "levelId": 0,
  "proficiencyExpectedId": 0,
  "proficiencyExpected": "",
  "courseProvider": ""
};

function CommonFilterModal({isMobile, searchFilterData, isMainRole, clearFilterData,clearFilterData1}) {
    const [isFieldEmpty, setIsFieldEmpty] = useState(false);
    const [skillsList, setSkillsList] = useState([]);
    const [levelsList, setLevelsList] = useState([]);
    const [proficiencyList, setProficiencyList] = useState([]);
    const [jobGroupSearch, setJobGroupSearch] = useState("");
    const [jobNameSearch, setJobNameSearch] = useState("");
    const [skillSearch, setSkillSearch] = useState({});
    const [levelSearch, setLevelSearch] = useState({});
    const [proficiencyExpected, setProficiencyExpected] = useState({});
    const [proficiencyState, setProficiencyState] = useState({});
    useEffect(() => {
       getSkillOptions();
       getlevelOptions();
       getProficiencyOptions();
    }, [])

    useEffect(() => {
      clearSearchFields1();
    }, [isMainRole])

    const getSkillOptions = () => {
        let apiUrl = `${API.GET_SKILLS_TYPE}`;
        axios({
          method: "GET",
          url: apiUrl,
        })
          .then((res) => {
            if (res.status === 200) {
              let skillsListOptions = [];
              skillsListOptions = res?.data?.map((skill) => {
                return {
                  value: skill.id + "," + skill.skillName,
                  label: (
                    <>
                      <span>{skill.skillName}</span>
                    </>
                  ),
                };
              });
              setSkillsList(skillsListOptions);
            }
          })
          .catch((error) => {
            logoutFunction(error?.response?.status);
          });
    }

    const getlevelOptions = () => {
      let apiUrl = `${API.GET_LEVEL_MASTERDATA}`;
      axios({
        method: "GET",
        url: apiUrl,
      })
        .then((res) => {
          if (res.status === 200) {
            let levelListOptions = [];
            levelListOptions = res?.data?.map((level) => {
              return {
                value: level.id + "," + level.name,
                label: (
                  <>
                    <span>{level.name}</span>
                  </>
                ),
              };
            });
            setLevelsList(levelListOptions);
          }
        })
        .catch((error) => {
          logoutFunction(error?.response?.status);
          console.log(error);
          this.setState({ isRequestLoader: false });
          // swal("Error!", "Something went wrong. Please try again.", "warning");
        });
    }

    const getProficiencyOptions = () => {
      let apiUrl = `${API.GET_PROFICIENCY}`;
      axios({
        method: "GET",
        url: apiUrl,
      })
        .then((res) => {
          if (res.status === 200) {
             let proficiencyList = res?.data?.map((proficiency) => {
              return {
                value: proficiency.id + "," + proficiency.name,
                label: (
                  <>
                    <span>{proficiency.name}</span>
                  </>
                ),
              };
            });
            setProficiencyList(proficiencyList);
          }
        })
        .catch((error) => {
          logoutFunction(error?.response?.status);
          console.log(error);
          this.setState({ isRequestLoader: false });
          // swal("Error!", "Something went wrong. Please try again.", "warning");
        });
    }

    const searchFilterMainRoles = () => {
      let object = {
        "job": jobNameSearch,
        "jobGroup": jobGroupSearch,
        "skillId": skillSearch?.value ? skillSearch?.value?.split(",")[0] : 0,
        "skill": skillSearch?.value ? skillSearch?.value?.split(",")[1] : "",
        "level": levelSearch?.value ? levelSearch?.value?.split(",")[1] : "",
        "proficiency": proficiencyState?.value ? proficiencyState?.value?.split(",")[1] : "",
        "proficiencyId": proficiencyState?.value ? proficiencyState?.value?.split(",")[0] : 0,
        "levelId": levelSearch?.value ? levelSearch?.value?.split(",")[0] : 0,
        "proficiencyExpectedId": proficiencyExpected?.value ? proficiencyExpected?.value?.split(",")[0] : 0,
        "proficiencyExpected": proficiencyExpected?.value ? proficiencyExpected?.value?.split(",")[1] : "",
        "courseProvider": ""
      };
      if (object.job != "" || object.jobGroup != "" || object.skillId > 0  || object.proficiencyId > 0  || object.levelId > 0  || object.proficiencyExpectedId > 0){
        handleCloseModal();
        searchFilterData(object);
        setIsFieldEmpty(false);
      }else {
        setIsFieldEmpty(true);
      }
    }
    const clearSearchFields = () => {
      handleCloseModal();
      setJobGroupSearch("");
      setJobNameSearch("");
      setSkillSearch({});
      setLevelSearch({});
      setProficiencyExpected({});
      setIsFieldEmpty(false);
      setProficiencyState({});
      clearFilterData(obj);
    }

    const clearSearchFields1 = () => {
      handleCloseModal();
      setJobGroupSearch("");
      setJobNameSearch("");
      setSkillSearch({});
      setLevelSearch({});
      setProficiencyExpected({});
      setIsFieldEmpty(false);
      setProficiencyState({});
      clearFilterData1();
    }

    const handleCloseModal = () => {
      $("#mainCommitteeRolesModal").removeClass("show");
      $("body").removeClass("scrollhide");
      setIsFieldEmpty(false);
    }
    return (
        <div
        className="offcanvas offcanvas-end offcanvasStyle"
        tabIndex={-1}
        data-bs-scroll="false"
        data-bs-backdrop="false"
        id="mainCommitteeRolesModal"
        aria-labelledby="offcanvasScrollingLabel"
        >
        <div
          className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3"
            }`}
        >
          <h6 id="offcanvasRightLabel" className="modal-title fw-600">
            {"Search"}
          </h6>
          <button
            className={`text-reset offcavasclose buttonstyle background-white ${isMobile ? "pr-0" : ""
              }`}
              onClick={() => handleCloseModal()}
            // data-bs-dismiss="offcanvas"
          >
            <CommonIcon fileName="CrossIcon" />
          </button>
          <button
          className="display-none"
              id="closeButton"
            data-bs-dismiss="offcanvas"
          >
          </button>
        </div>
        <div className="offcanvas-body px-4 pt-0">
          <div className="row">
            <div
              className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 mb-2`}
            >
              <div className="form-group">
                <div className="row">
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-2 mb-2">
                    <label
                      className={`label-text  ${isMobile
                          ? "d-flex pt-2 mb-2-ledger"
                          : "d-flex mb-2-ledger mb-1"
                        }`}
                    >
                      <CommonIcon 
                        className="img-width-15"
                        fileName="courseMaster"
                      />
                      <span className="pl-5 properties-search-span">
                        Job group
                      </span>
                    </label>
                    <input
                      type="text"
                      className={`form-control form-text-box my-input-class input-height`}
                      style={{
                        "border-radius": "0"
                      }}
                      placeholder=""
                      value={jobGroupSearch}
                      onChange={(e) => setJobGroupSearch(e.target.value)}
                    />
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-2 mb-2">
                    <label
                      className={`label-text  ${isMobile
                          ? "d-flex pt-2 mb-2-ledger"
                          : "d-flex mb-2-ledger mb-1"
                        }`}
                    >
                      <CommonIcon
                        className="properties-img-2"
                        fileName="jobicon"
                      />
                      <span className="pl-5 properties-search-span">
                        Job 
                        </span>
                    </label>

                    <input
                      type="text"
                      className={`form-control form-text-box my-input-class input-height`}
                      style={{
                        "border-radius": "0"
                      }}
                      placeholder=""
                      value={jobNameSearch}
                      onChange={(e) => setJobNameSearch(e.target.value)}
                    />
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-2 mb-2">
                    <label
                      className={`label-text  ${isMobile
                          ? "d-flex pt-2 mb-2-ledger"
                          : "d-flex mb-2-ledger mb-1"
                        }`}
                    >
                      <CommonIcon
                        className="properties-img-2"
                        fileName="skillIcon"
                      />
                      <span className="pl-5 properties-search-span">
                        Skill
                      </span>                      
                    </label>
                    <Select
                      className={` text-12-normal-select my-input-class`}
                      classNamePrefix="assigngroups"
                      options={skillsList}
                      placeholder="Please select an option"
                      styles={styles}
                      menuPosition="fixed"
                      menuPlacement="auto"
                      isClearable={true}
                      isMulti={false}
                      isSearchable={true}
                      value={skillSearch}
                      onChange={(e) => setSkillSearch(e)}
                    />
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-2 mb-2">
                    <label
                      className={`label-text  ${isMobile
                          ? "d-flex pt-2 mb-2-ledger"
                          : "d-flex mb-2-ledger mb-1"
                        }`}
                    >
                      <CommonIcon
                        className="properties-img-2"
                        fileName="levelIcon"
                      />
                      <span className="pl-5 properties-search-span">Level</span>
                    </label>
                    <Select
                      className={`text-12-normal-select my-input-class`}
                      classNamePrefix="assigngroups"
                      value={levelSearch}
                      options={levelsList}
                      onChange={(e) => setLevelSearch(e)}
                      placeholder="Please select an option"
                      styles={styles}
                      menuPosition="fixed"
                      menuPlacement="auto"
                      isClearable={true}
                      isMulti={false}
                      isSearchable={true}
                    />
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-2 mb-2">
                    <label
                      className={`label-text  ${isMobile
                          ? "d-flex pt-2 mb-2-ledger"
                          : "d-flex mb-2-ledger mb-1"
                        }`}
                    >
                      <CommonIcon
                        className="img-width-15"
                        fileName="proficiencyExpected"
                      />
                      <span className="pl-5 properties-search-span">
                        Proficiency expected
                      </span>
                    </label>
                    <Select
                      className={`text-12-normal-select my-input-class`}
                      classNamePrefix="assigngroups"
                      value={proficiencyExpected}
                      onChange={(e) => setProficiencyExpected(e)}
                      options={proficiencyList}
                      placeholder="Please select an option"
                      styles={styles}
                      menuPosition="fixed"
                      menuPlacement="auto"
                      isClearable={true}
                      isMulti={false}
                      isSearchable={true}
                    //   onChange={this.onchangeProficiecy}
                    />
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-2 mb-2">
                    <label
                      className={`label-text  ${isMobile
                          ? "d-flex pt-2 mb-2-ledger"
                          : "d-flex mb-2-ledger mb-1"
                        }`}
                    >
                      <CommonIcon
                        className="img-width-15"
                        fileName="proficiencyExpected"
                      />
                      <span className="pl-5 properties-search-span">
                        Proficiency
                      </span>
                    </label>
                    <Select
                      className={`text-12-normal-select my-input-class`}
                      classNamePrefix="assigngroups"
                      value={{
                        value:
                          proficiencyState?.value,
                        label: (
                          <>
                            <span className={`${proficiencyState?.value?.split(",")[0] == 45 && 'green-color'} ${proficiencyState?.value?.split(",")[0] == 46 && 'blue-color'} ${proficiencyState?.value?.split(",")[0] == 47 && 'orange-color'} ${proficiencyState?.value?.split(",")[0] == 48 && 'brown-color'} ${proficiencyState?.value?.split(",")[0] == 50 && 'yellow-color'}`}>{proficiencyState?.value?.split(",")[1]}</span>
                          </>
                        ),
                      }}
                      onChange={(e) => setProficiencyState(e)}
                      options={proficiencyOptions}
                      placeholder="Please select an option"
                      isClearable={true}
                      isMulti={false}
                      isSearchable={true}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999, width: "1000px" }),
                        ...colorStyles,
                        ...{
                          control: (styles) => ({
                            ...styles,
                          })
                        }
                      }}
                    />
                  </div>
                </div>
              </div>{" "}
            </div>
          </div>
          {isFieldEmpty && (
            <span className="send-rework-label">
              Atleast one field is required
            </span>
          )}
          <div className="col-12 col-sm-12 col-md-6 col-lg-6 mt-3 mb-1">
            <div className="d-flex mb-1">
                <button
                // data-bs-dismiss="offcanvas"
                className="btn rejectbutton"
                onClick={() => clearSearchFields()}
                >
                <CommonIcon
                    className="button-img"
                    fileName="ButtonRejectApprovalIcon"
                />
                <span className="px-1">Clear</span>
                </button>
                <button
                //  data-bs-dismiss= {"offcanvas"}
                className={`btn approvebutton d-flex gap-1 mx-2`}
                onClick={() => searchFilterMainRoles()}
                >
                <span>
                    <CommonIcon fileName="searchableIcon" />
                </span>
                <span className="model-label pl-vendor3 pl-2">
                    Search
                </span>
                </button>
            </div>
          </div>
        </div>
      </div>
    )
};

export default CommonFilterModal;